import React from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import AdjustmentsField from '@afosto/app-components-react/AdjustmentsField';
import translations from './translations';

const AdjustmentsFormSection = () => {
  const intl = useIntl();

  return (
    <Card style={{ marginBottom: 8 }}>
      <CardHeader
        title={intl.formatMessage(translations.title)}
        titleTypographyProps={{ variant: 'h6' }}
      />
      <CardContent>
        <AdjustmentsField showLabel={false} atLeastOneRequired />
      </CardContent>
    </Card>
  );
};

export default AdjustmentsFormSection;
